import { eAppContext, LoginOut, eLogOutMode, QueovalDik, LoginExtranetAppModel } from '../models';
import { CoreService } from '../services';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { LoginElearningService } from './common.login.srv.elearning';

export class LoginExtranetService extends LoginElearningService {
  constructor(
    protected indParam: CoreService,
    protected http: HttpClient
  ) { super(indParam, http); }

  public mailLogin(user: string, pswd: string, db: string, context: eAppContext): Observable<QueovalDik> {
    return this.Log(context, user, pswd, db, true).pipe(mergeMap((result: string) => {
      if (result === 'OK') {
        this.setLoginResult(new LoginOut(true, eLogOutMode.EXTRANETMAIL));
        return of(new QueovalDik('OK', ''));
      }
      else {
        switch (result) {
          case 'ERR DB': return of(new QueovalDik('ERROR', `Le nom de la base de données fourni ${db} n'existe pas`));
          case 'ERR US': return of(new QueovalDik('ERROR', 'Veuillez vérifier votre login et mot de passe'));
          default: return of(new QueovalDik('ERROR', result));
        }
      }
    }));
  }

  public LoginFromExpert(user: string, pswd: string, db: string, cntx: eAppContext): Observable<QueovalDik> {
    const model: LoginExtranetAppModel = new LoginExtranetAppModel();
    model.UserName = user;
    model.Password = pswd;
    model.Source = 'EXTRANET';
    model.DataSource = db;
    model.IsdoubleEncryption = true;

    return this.LoginApp<LoginExtranetAppModel>(this.indParam.AppParams.apiUrl, model, cntx).pipe(mergeMap((data: string) => {
      if (data === 'OK') {
        this.setLoginResult(new LoginOut(true, eLogOutMode.EXTRANETEXPERT));
        return of(new QueovalDik('OK', ''));
      }
      else
        return of(new QueovalDik('ERROR', data));
      //this.justInit();
    }));
  }

}
